import { render } from "./FullReport.vue?vue&type=template&id=085b2bfa&scoped=true"
import script from "./FullReport.vue?vue&type=script&lang=js"
export * from "./FullReport.vue?vue&type=script&lang=js"

import "./FullReport.vue?vue&type=style&index=0&id=085b2bfa&lang=scss"
import "./FullReport.vue?vue&type=style&index=1&id=085b2bfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085b2bfa"]])

export default __exports__